export const createMediaSchema = ({ getPacketWeightString, getPacketCostString }) => {
  return {
    title: 'Medium Details',
    summary: {
      title: 'Details',
      fields: [
        { key: 'brand', label: 'Brand' },
        {
          key: 'packetWeight',
          label: 'Packet Weight',
          getValue: (row) => getPacketWeightString(row),
        },
        {
          key: 'packetCost',
          label: 'Packet Cost',
          getValue: (row) => getPacketCostString(row),
        },
      ],
    },
    sections: [
      {
        title: 'Notes',
        fields: [{ key: 'notes', label: 'Notes' }],
      },
    ],
  };
};
